import { Component, OnInit } from '@angular/core';
import { TutorialPanelComponent } from '../tutorial-panel/tutorial-panel.component';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

@Component({
  selector: 'mobile-tutorial-panel',
  template: require('./mobile-tutorial-panel.component.html'),
  styles: [require('./mobile-tutorial-panel.component.css')]
})
export class MobileTutorialPanelComponent extends TutorialPanelComponent {
  set activeVideo(v: string | null)
  {
    this.workspaceService.data.activeTutorialVideo = v;
  }

  get shown()
  {
    return this.workspaceService.data.tutorialPanelShown;
  }

  set shown(v)
  {
  }

  constructor(public workspaceService: WorkspaceServiceService) { super(workspaceService) }

  preloadVideos(){}

}
